// export const API_prod: string = 'https://kit-global.agency/PHP/send-mail.php'
export const API_dev_info: string = 'https://kit-global.agency/PHP/send-mail.php';
export const API_dev_order: string = 'https://kit-global.agency/PHP/send-order-mail.php';